var render = function () {
  var _vm$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [(_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length ? [_c('v-data-table', _vm._b({
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "mobile-breakpoint": _vm.$vuetify.breakpoint.thresholds.sm
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false)), _c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11",
      "color": "primary"
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })] : [_c('p', {
    staticClass: "page-text grey-6--text text-center"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 신용카드 거래 내역이 없습니다. ")])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }